import http from '../../http-common';

class EventPracticePriceService {
    create(data) {
        return http.post('/promoter/eventDetails/practice/price', data);
    }
    getAll(eventId, practiceId) {   
        return http.get(`/promoter/eventDetails/${eventId}/practice/${practiceId}/price`);
    }
    update(data) {
        return http.put('/promoter/eventDetails/practice/price', data);
    }
    delete(eventId, practiceId, priceId) {
        return http.delete(`/promoter/eventDetails/${eventId}/practice/${practiceId}/price/${priceId}`);
    }
}


export default new EventPracticePriceService();
